<template>
    <div class="gh-mobile-menu">
        <button
                :class="triggerButtonClasses"
                @click="openMobileMenu">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
        </button>

        <slot>
            <el-dialog
                    customClass="gh-mobile-menu__modal"
                    top="10%"
                    :showClose="false"
                    :modal-append-to-body="false"
                    :visible.sync="visibleMenu">
                <div class="gh-mobile-menu__items" @click="closeMobileMenu">
                    <slot name="menu"></slot>
                </div>
            </el-dialog>
        </slot>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                visibleMenu: false,
            }
        },

        computed: {
            triggerButtonClasses() {
                return {
                    'gh-mobile-menu__trigger': true,
                    hamburger: true,
                    'hamburger--elastic': true,
                    'is-active': this.visibleMenu
                }
            },

            member() {
                return this.$store.state.auth.me;
            },

            isGuest() {
                return ! this.$store.state.auth.authenticated;
            },
        },

        methods: {
            openMobileMenu() {
                this.visibleMenu = true;
            },

            closeMobileMenu() {
                this.visibleMenu = false;
            }
        },

        watch: {
            $route(newRoute) {
                this.visibleMenu = false;
            }
        }
    }
</script>